import ProductionSegment from "./ProductionSegment";
import { useAlternateTimelines } from "components/Dashboard/HubletView/SingleTimeline/singleTimelineStore";
import { SHRINK_TIMELINE_HEIGHT } from "constants/constants";

export function AlternateTimelineProductionSegments({
  processId,
  timelineIdx,
}: {
  processId: string;
  timelineIdx: number;
}): React.JSX.Element {
  const [alternateTimelines] = useAlternateTimelines();
  const segments = alternateTimelines[processId] || [];

  return (
    <g
      style={{ transition: "transform 0.3s" }}
      transform={`translate(0, ${
        // when tags are highlighted, to preserve vertical space, move alternate timeline up to overlap with original timeline
        SHRINK_TIMELINE_HEIGHT + 2
      })`}
    >
      {segments.map(ps => (
        <ProductionSegment
          key={`${processId}-ps-${ps.range.ge}`}
          height={SHRINK_TIMELINE_HEIGHT}
          timelineIdx={timelineIdx}
          segment={ps}
          machemetryId={processId}
          showSubSegments={false}
        />
      ))}
    </g>
  );
}
